export enum Palette {
    Dawn = '#FAFFA7',
    Burgundy = '#4D1520',
    DeepBurgundy = '#2F080F',
    Canvas = '#FBFAF4',
    Stone = '#F2EDE8',
    Sun = '#FFFF7D',
    Sunrise = '#FF843D',
    Navy = '#0E091F',
    WarmStone = '#F4EAE1',
    PureWhite = '#FFFFFF',
}
